export function countryInterpretor(country: string) {
    if (country.toLowerCase() === 'ca') {
        return 'Canada';
    }
    if (country.toLowerCase() === 'canada') {
        return 'CA';
    }
    return 'CA';
}
